import {Col, Row} from 'react-bootstrap';
import {useState} from 'react';
import '../../styles/back-office/sync-logs.scss';
import SyncLogList from '../../components/back-office/SyncLogList';
import {syncLogTypes} from '../../types/sync-log';
import {LuBox, LuShoppingCart} from 'react-icons/lu';
import {BsCashCoin, BsBox2, BsClockHistory} from 'react-icons/bs';

const SyncLog = () => {
  const [syncLogType, setSyncLogType] = useState();

  return (
    <>
      {syncLogType ? (
        <SyncLogList syncLogType={syncLogType} setSyncLogType={setSyncLogType} />
      ) : (
        <Row className='sync-logs'>
          <Col xs={3}>
            <div className='custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
              onClick={() => setSyncLogType(syncLogTypes.product)}>
              <LuBox size={'24px'} className='me-2' />
              Products
            </div>
          </Col>
          <Col xs={3}>
            <div className='custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
              onClick={() => setSyncLogType(syncLogTypes.stock)}>
              <LuShoppingCart size={'24px'} className='me-2' />
              Stocks
            </div>
          </Col>
          <Col xs={3}>
            <div className='custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
              onClick={() => setSyncLogType(syncLogTypes.price)}>
              <BsCashCoin size={'24px'} className='me-2' />
              Prices
            </div>
          </Col>
          <Col xs={3}>
            <div className='custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
              onClick={() => setSyncLogType(syncLogTypes.order)}>
              <BsBox2 size={'22px'} className='me-2' />
              Orders
            </div>
          </Col>
          <Col xs={3}>
            <div className='mt-4 custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
              onClick={() => setSyncLogType(syncLogTypes.orderStatus)}>
              <BsClockHistory size={'22'} className='me-2' />
              Order Statuses
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default SyncLog;
